const notices = {
  account_suspended: 'Your account is suspended. Please contact support.',
  account_inactive: 'Your account is not active. Please contact support.',
};

export const accountAccessNotice = reason => Object.prototype.hasOwnProperty.call(notices, reason) ? notices[reason] : '';

export const getAccountAccessError = error => {
  const detail = error.response?.data?.detail;
  if (error.response?.status !== 403 || !Object.prototype.hasOwnProperty.call(notices, detail?.code)) {
    return null;
  }
  return { code: detail.code, message: detail.message || notices[detail.code] };
};
